import { useQuery, useQueryClient } from 'react-query';
import { useEffect } from 'react';
import { getTeamDetails } from '../api/services/team';
import { auth, useAuthState } from '../api/services/firebase';
import useTeamStore from '../store/teamStore';

const useTeamDetails = (teamId) => {
  const queryClient = useQueryClient();

  const [user] = useAuthState(auth);
  const isUserAvailable = !!user;

  const setTeamName = useTeamStore((state) => state.setTeamName);

  if (!isUserAvailable) {
    queryClient.removeQueries({ queryKey: ['team-details', teamId] });
  }

  const { data = {}, isLoading } = useQuery({
    queryKey: ['team-details', teamId],
    queryFn: getTeamDetails,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled: isUserAvailable && !!teamId,
  });

  useEffect(() => {
    const { teamName } = data;
    setTeamName(teamName, isLoading);
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [data.teamName, isLoading, setTeamName]);
};

export default useTeamDetails;
